// See the note in glide-slider.ts - the package's `require` entry is a UMD file that bundlers
// parse as ESM (because of `"type": "module"`), so it exports nothing. Use the ESM build.
import Glide from '@glidejs/glide/dist/glide.esm.js'


export class GlideCarousel {
    duration: number;
    transition: number;
    class: string;
    transitionType: string;
    perView: number;
    gap: number;
    type: string;
    constructor(options: { class: string; duration?: number; transition?: number; type?: string, perView?: number; gap?: number; }) {
        this.class = options.class
        this.perView = options.perView || 1;
        this.gap = options.gap || 15;
        this.type = options.type || 'carousel'
        this.init()
    }

    init() {
        console.log('Glide: ', this.class)
        const glide = new Glide(`.${this.class}`, {
            perView: this.perView,
            type: this.type,
            startAt: 0,
            gap: this.gap,
            animationTimingFunc: 'ease-in-out', 
            animationDuration: 300,
            duration: 300,
            breakpoints: {
                768: { perView: 1 },
                992: { perView: this.perView > 2 ? 2 : this.perView },
            }
        });

        glide.on('mount.after', () => {
            const bullets = document.querySelectorAll(`.${this.class} .glide__bullet`);
            
            bullets.forEach(bullet => {
                bullet.setAttribute('tabindex', '-1');
                bullet.setAttribute('aria-hidden', 'true');
                bullet['style'].pointerEvents = 'none';
            });
        });

        glide.mount();
        
      
    }
}